import React, { useState } from "react";
import { Copy, Check, ExternalLink } from "lucide-react";
import { toast } from "sonner";

const CODE = "TURISTAR";
const RESERVE_URL = "https://viagensorion.com";

export default function AnnouncementBar() {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CODE);
      setCopied(true);
      toast.success("Cupom copiado!", {
        description: `${CODE} — 10% OFF na sua reserva`,
        duration: 2600,
      });
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Não foi possível copiar. Tente selecionar manualmente.");
    }
  };

  return (
    <div
      className="relative bg-gradient-to-r from-[#1c0a25] via-[#2C1139] to-[#1c0a25] text-white overflow-hidden"
      data-testid="announcement-bar"
      role="complementary"
      aria-label="Cupom exclusivo Viagens Orion"
    >
      <span className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-orion-orange/70 to-transparent pointer-events-none" />
      <span className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-orion-gold/40 to-transparent pointer-events-none" />

      <div className="container-orion py-2.5 flex items-center justify-center gap-3 md:gap-6 text-xs md:text-sm flex-wrap">
        <div className="hidden sm:flex items-center gap-2 text-orion-gold">
          <span className="text-[10px] uppercase tracking-[0.32em] font-semibold">Viagens Orion</span>
        </div>

        <span className="text-white/85 text-center">
          Ganhe <strong className="text-white">10% OFF</strong> na sua reserva com o cupom
        </span>

        <button
          onClick={copy}
          data-testid="announcement-copy"
          aria-label={`Copiar cupom ${CODE}`}
          className="inline-flex items-center gap-2 border border-dashed border-orion-orange/70 bg-white/5 hover:bg-white/10 hover:border-orion-orange transition-colors px-3 py-1 font-mono tracking-widest text-sm"
        >
          <span className="text-orion-orange font-semibold">{CODE}</span>
          {copied ? <Check size={13} className="text-emerald-300" /> : <Copy size={13} className="text-white/60" />}
        </button>

        <a
          href={RESERVE_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="announcement-reserve"
          className="inline-flex items-center gap-1 text-orion-orange hover:text-white underline underline-offset-4 decoration-1 hover:decoration-2 font-semibold uppercase tracking-widest text-[11px]"
        >
          Buscar Pacotes <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
}
